module.exports = __webpack_public_path__ + "media/images/iconDelete__errorRed--dark-b63f4f8e1f7d0e93c1cda5fe70a89116.png";